module.exports = __webpack_public_path__ + "static/img/bg_mod_energy.acd04703.jpg";